import React from 'react';
import "./Form.scss";

function Form({ children, ...props }: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>) {
    return (
        <form className='Form' {...props}>
            {children}
        </form>
    )
}

export function SimpleForm({ children, ...props }: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>) {
    return (
        <form {...props}>
            {children}
        </form>
    )
}
export function FormGroup({ children, ...props }: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
    return (
        <div className='FormGroup' {...props}>
            {children}
        </div>
    )
}


export default Form